import { use, useMemo } from 'react'

import { ChatContext } from '@app/context'
import { getConversationById } from '@app/helpers'

import { useConversationID } from './useConversationID'

export const useConversation = () => {
  const id = useConversationID()
  const { state } = use(ChatContext)

  return useMemo(() => {
    if (!id) {
      return null
    }

    return getConversationById(state.conversations, id)
  }, [state.conversations, id])
}
